import FaqsPage from './components/faqs-page';

new FaqsPage(document.body);
